import BaseModal from "../../../components/ui/BaseModal";
import BaseButton from "../../../components/ui/BaseButton";
import { useFormik } from "formik";
import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { addWorkOrderNote, updateWorkOrderApi } from "../../../services/api/workOrder";
import { useUpdateWorkOrder } from "../../../hooks/useUpdateWorkOrder";

const validationSchema = yup.object({
    comment: yup.string().required("Note is required"),
});

const AddWorkOrderNoteModal = ({
    workOrderDetail,
    open,
    close,
}) => {
    const { updateWorkOrder } = useUpdateWorkOrder();
    const formik = useFormik({
        initialValues: {
            comment: workOrderDetail?.notes || "",
        },
        validationSchema: validationSchema,
        onSubmit: () => {
            handleAddNoteButton();
        },
        validateOnBlur: true,
        validateOnChange: true,
        enableReinitialize: true,
    });

    const {
        isPending: isAddNoteLoading,
        mutateAsync: addNoteMutation,
        refetch: refetchAddNote,
    } = useMutation({
        mutationFn: addWorkOrderNote,
    });

    const handleAddNoteButton = async () => {
        try {
            await addNoteMutation({
                workOrderId: workOrderDetail?.id,
                notes: formik.values.comment,
            });
            updateWorkOrder();
            close(false);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <BaseModal
            className="-top-[200px] overflow-auto"
            open={open}
            close={() => {
                close(false);
            }}
        >
            <div className="py-7 px-12 xl:w-[1000px] lg:w-[900px] sm:w-[700px]">
                <h6 className="text-dark font-normal border-b pb-1">Add Note</h6>

                <textarea
                    className="w-full border rounded-md mt-4 h-48 p-2 text-[13px]"
                    id="comment"
                    name="comment"
                    value={formik.values.comment}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                />

                {formik.touched.comment && formik.errors.comment && (
                    <p className="text-red-500 text-xs mt-1">{formik.errors.comment}</p>
                )}
            </div>

            <div
                className="d-flex content-center bg-white py-6"
                style={{
                    boxShadow: "0px 0px 14px 0px rgba(0, 0, 0, 0.07)",
                }}
            >
                <BaseButton
                    className="px-[28px] py-[5px] bg-light text-primary hover:!text-primary"
                    variant="outlined"
                    onClick={() => close(false)}
                >
                    Cancel
                </BaseButton>

                <BaseButton
                    isLoading={isAddNoteLoading}
                    disabled={!formik.isValid || !formik.dirty}
                    loaderSize={24}
                    loaderColor="primary"
                    className="px-[40px] py-[5px] ml-4"
                    color="primary"
                    onClick={formik.handleSubmit}
                >
                    Save
                </BaseButton>
            </div>
        </BaseModal>
    );
};

export default AddWorkOrderNoteModal;
